import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ApplicationRef, ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, Injector, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OnboardingCompanyComponent } from '../onboarding-company/onboarding-company.component';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';
import { GlobalService } from 'src/app/services/global/global.service';

import { DeleteItemComponent } from '../delete-item/delete-item.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HireRecruiterComponent } from '../dialog-modal/hire-recruiter/hire-recruiter.component';
import { EditUserComponent } from '../dialog-modal/edit-user/edit-user.component';
// import {  } from '../../../assets/js/custom-select.js'; 


@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})

export class TestComponent {
  @ViewChild('hoverDiv') hoverDiv!: ElementRef;

  items = [
    {name:"Item 1",content:"Content 1"},
    {name:"Item 2",content:"Content 2"},
    {name:"Item 3",content:"Content 3"}
  ];  // Example items
  hoverContent: any = '';

  public dataArr:any[]=[]
  public filter:any[]=[]
  currentDate: Date = new Date();
  viewMode: 'month' | 'week' = 'month'; // Default to 'month' view
  testForm!:FormGroup;

  constructor(private changeDetectorRef: ChangeDetectorRef,private fb:FormBuilder,private userService:UserManagementService,
    private renderer: Renderer2
  ) {}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.testForm=this.fb.group({
      url:['']
    })
    window.scrollTo(0, 0);
  }
  getViewDates(): Date[] {
    if (this.viewMode === 'week') {
      // Display days of the current week
      const daysOfWeek :any= [];
      const startDate = new Date(this.currentDate);
      while (startDate.getDay() !== 0) {
        startDate.setDate(startDate.getDate() - 1);
      }
      for (let i = 0; i < 7; i++) {
        daysOfWeek.push(new Date(startDate));
        startDate.setDate(startDate.getDate() + 1);
      }
      return daysOfWeek;
    } else {
      // Display days of the current month
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const firstDayOfMonth = new Date(year, month, 1).getDay();
      const daysOfMonth :any[]= [];
      for (let i = 1 - firstDayOfMonth; i <= daysInMonth; i++) {
        daysOfMonth.push(new Date(year, month, i));
      }
      return daysOfMonth;
    }
  }

  getMonthsOfYear(): string[] {
    return [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
  }

  getYears(): number[] {
    const currentYear = this.currentDate.getFullYear();
    const startYear = currentYear - 10;
    const endYear = currentYear + 10;
    return Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
  }

  toggleViewMode() {
    this.viewMode = this.viewMode === 'month' ? 'week' : 'month';
    // Manually trigger change detection to update the view
    this.changeDetectorRef.detectChanges();
  }

  prevYear() {
    const currentYear = this.currentDate.getFullYear();
    this.currentDate.setFullYear(currentYear - 1);
    // Manually trigger change detection to update the view
    this.changeDetectorRef.detectChanges();
  }

  prevMonth() {
    const currentMonth = this.currentDate.getMonth();
    this.currentDate.setMonth(currentMonth - 1);
    // Manually trigger change detection to update the view
    this.changeDetectorRef.detectChanges();
  }

  nextMonth() {
    const currentMonth = this.currentDate.getMonth();
    this.currentDate.setMonth(currentMonth + 1);
    // Manually trigger change detection to update the view
    this.changeDetectorRef.detectChanges();
  }

  nextYear() {
    const currentYear = this.currentDate.getFullYear();
    this.currentDate.setFullYear(currentYear + 1);
    // Manually trigger change detection to update the view
    this.changeDetectorRef.detectChanges();
  }

  // Function to navigate to the previous week (for week view)
  prev() {
    const interval = this.viewMode === 'week' ? 7 : 1;
    const currentTimestamp = this.currentDate.getTime();
    const newTimestamp = currentTimestamp - interval * 24 * 60 * 60 * 1000;
    this.currentDate = new Date(newTimestamp);
    // Manually trigger change detection to update the view
    this.changeDetectorRef.detectChanges();
  }

  // Function to navigate to the next week (for week view)
  next() {
    const interval = this.viewMode === 'week' ? 7 : 1;
    const currentTimestamp = this.currentDate.getTime();
    const newTimestamp = currentTimestamp + interval * 24 * 60 * 60 * 1000;
    this.currentDate = new Date(newTimestamp);
    // Manually trigger change detection to update the view
    this.changeDetectorRef.detectChanges();
  }
  // onSubmit()
  openNewTab(){
    let data={
      url:this.testForm.get('url')?.value,
    }
    this.userService.testUrl(data).subscribe((result:any)=>{
      if(result.status==200){
        window.open(result.msg,"_blank")
      }
    })
  }
  submitSamePage(){
    let data={
      url:this.testForm.get('url')?.value,
    }
    this.userService.testUrl(data).subscribe((result:any)=>{
    })
  }
  onHover(event: MouseEvent, index: number) {
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();
    const hoverDiv = this.hoverDiv.nativeElement;

    this.hoverContent = this.items[index];  // Set the content based on the hovered item
    this.renderer.setStyle(hoverDiv, 'top', `${rect.bottom}px`);
    this.renderer.setStyle(hoverDiv, 'left', `${rect.left}px`);
    this.renderer.setStyle(hoverDiv, 'display', 'block');
  }

  onHoverOut() {
    this.renderer.setStyle(this.hoverDiv.nativeElement, 'display', 'none');
  }
}
